// extracted by mini-css-extract-plugin
module.exports = {"terms":"LegalDisclaimer_terms__IxC_M","newsletterLabel":"LegalDisclaimer_newsletterLabel__ig0PV","leftToRight":"LegalDisclaimer_leftToRight__b1Oxq"};